// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"CmsRichText_icomoon-font__2u4XV","CmsRichtext":"CmsRichText_CmsRichtext__3uQE4","CmsSmallPrint":"CmsRichText_CmsSmallPrint__1tCzS"};